import { defineSlotRecipe } from "@pandacss/dev";

export const aromaMessageBubble = defineSlotRecipe({
  className: "aroma-message-bubble",
  jsx: ["MessageBubble"],
  slots: ["message", "icon"],
  base: {
    message: {
      borderRadius: "2xl",
      height: "fit-content",
      maxWidth: 400,
      padding: "padding.2",
      flexShrink: 0,
      textStyle: "paragraph.m.regular",
    },
  },
  variants: {
    type: {
      primary: {
        message: {
          background: "background.decorative.blue.base-subtle",
        },
      },
      secondary: {
        message: {
          background: "background.neutral.base.subtler",
        },
      },
      ai: {
        message: {
          background: "background.ai.subtle",
        },
      },
    },
    rank: {
      first: {},
      middle: {},
      last: {},
      solo: {},
    },
  },
  defaultVariants: {
    type: "primary",
    rank: "first",
  },
  compoundVariants: [
    //Primary variants
    {
      type: "primary",
      rank: "first",
      css: {
        message: {
          borderBottomRightRadius: "s",
        },
      },
    },
    {
      type: "primary",
      rank: "middle",
      css: {
        message: {
          borderTopRightRadius: "s",
          borderBottomRightRadius: "s",
        },
      },
    },
    {
      type: "primary",
      rank: "last",
      css: {
        message: {
          borderTopRightRadius: "s",
        },
      },
    },
    //Secondary variants
    {
      type: "secondary",
      rank: "first",
      css: {
        message: {
          borderBottomLeftRadius: "s",
        },
        icon: {
          color: "text.neutral.base.subtler",
        },
      },
    },
    {
      type: "secondary",
      rank: "middle",
      css: {
        message: {
          borderTopLeftRadius: "s",
          borderBottomLeftRadius: "s",
        },
        icon: {
          color: "text.neutral.base.subtler",
        },
      },
    },
    {
      type: "secondary",
      rank: "last",
      css: {
        message: {
          borderTopLeftRadius: "s",
        },
        icon: {
          color: "text.neutral.base.subtler",
        },
      },
    },
    //AI variants
    {
      type: "ai",
      rank: "first",
      css: {
        message: {
          borderBottomRightRadius: "s",
        },
      },
    },
    {
      type: "ai",
      rank: "middle",
      css: {
        message: {
          borderTopRightRadius: "s",
          borderBottomRightRadius: "s",
        },
      },
    },
    {
      type: "ai",
      rank: "last",
      css: {
        message: {
          borderTopRightRadius: "s",
        },
      },
    },
  ],
});
